import { render, staticRenderFns } from "./_products-matrix.component.vue?vue&type=template&id=2bb60746&scoped=true"
import script from "./_products-matrix.component.vue?vue&type=script&lang=js"
export * from "./_products-matrix.component.vue?vue&type=script&lang=js"
import style0 from "./_products-matrix.component.vue?vue&type=style&index=0&id=2bb60746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb60746",
  null
  
)

export default component.exports